// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Rxpcq","box_shadow":"styles_box_shadow__Bs5z_","fade-out":"styles_fade-out__AxJqD","fade-in":"styles_fade-in__Mm__6"};